// extracted by mini-css-extract-plugin
export default {"component":"TrustpilotReviewsCarousel__component-GtlP","mw-i":"TrustpilotReviewsCarousel__mw-i-aeq4","largeTitle":"TrustpilotReviewsCarousel__largeTitle-uX79"};